import React, { useEffect, useState } from 'react';
import styled from "styled-components";
import { CON_PREFERENCIAS } from 'config/backend-siglas.config';
import { useAuth } from 'auth/AuthContext';
import { useNavigate } from 'react-router-dom';
import siconfiPages from 'config/siconfi.config';
import { breakLineWithOffset } from 'utils/stringUtils';

const Avatar = styled.div`
  .h-auto {
    height: auto;
  }

  .p-base {
    padding: 8px;
  }

  .br-sign-in {
    background-color: transparent;
  }
  
  .credenciais-nome, .credenciais-orgao, .credenciais-nome-perfil {
    font-size: 12px;
  }

  .credenciais-nome, .credenciais-nome-perfil {
    line-height: 8px;
  }

  .credenciais-orgao {
    line-height: 24px;
  }

  .credenciais-lh13 {
    line-height: 13px;
  }

  .credenciais-orgao.credenciais-lh13 {
    margin-top: 4px;
    margin-bottom: 4px;
  }
  
  #avatar-menu {
    position: absolute;
    box-shadow: rgba(0, 0, 0, 0.16) 0px 1px 6px 0px;
    right: 0px;
  }
`

function Credenciais({className, credentials}) {
  const [dropdownOpen, setDropDownOpen] = useState(false);
  const { remoteLogout, reverseSignOn, isAuthenticated, isAuthorized } = useAuth();
  const navigate = useNavigate();

  let nome = credentials?.nome ?? '';
  let orgao = credentials?.orgao ?? '';
  let nomePerfil = credentials?.nomePerfil ?? '';
  const numVinculos = Number(credentials?.numVinculos ?? 0);

  useEffect(() => {
    const onAnyWindowClickSetDropDownFalse = () => dropdownOpen && setDropDownOpen(false);
    
    window.addEventListener('click', onAnyWindowClickSetDropDownFalse, false);
    return () => window.removeEventListener('click', onAnyWindowClickSetDropDownFalse, false)
  }, [dropdownOpen])

  function handleToggleDropdown(event) {
    event.stopPropagation();
    setDropDownOpen(actualDropdownOpen => !actualDropdownOpen);
  }

  function handleAcessarAreaRestrita() {
    window.location.href = siconfiPages.LOGIN_AREA_RESTRITA;
  }

  let credenciaisNome = "";
  let credenciaisOrgao = "";
  let credenciaisPerfil = "";
  let credenciaisNomeLineHeight = "";
  let credenciaisOrgaoLineHeight = "";
  let credenciaisPerfilLineHeight = "";
  const credenciaisOffset = 35;

  if (nome.length > 0) {
    if (nome.length > credenciaisOffset) {
      credenciaisNomeLineHeight = " credenciais-lh13";
    }
    credenciaisNome = breakLineWithOffset(nome, credenciaisOffset);
  }
  if (orgao.length > 0) {
    if (orgao.length > credenciaisOffset) {
      credenciaisOrgaoLineHeight = " credenciais-lh13";
    }

    credenciaisOrgao = breakLineWithOffset(orgao, credenciaisOffset);
  }
  if (nomePerfil.length > 0) {
    if (nomePerfil.length > credenciaisOffset) {
      credenciaisPerfilLineHeight = " credenciais-lh13";
    }

    credenciaisPerfil = breakLineWithOffset(nomePerfil, credenciaisOffset);
  }

  return (
    <>
      {isAuthenticated &&
        <Avatar className={dropdownOpen ? "dropdown show" : "dropdown"}>
          <button
            className={`br-sign-in ${className} h-auto p-base`}
            type="button"
            id="avatar-dropdown-trigger"
            aria-label="avatar"
            onClick={handleToggleDropdown}
            aria-expanded={dropdownOpen}
            aria-controls="avatar-menu"
          >
            <span className="br-avatar" title={nome}>
              <span className="content">
                <i className="fas fa-user" aria-hidden="true"></i>
              </span>
            </span>
            <div className="ml-2 text-gray-80 text-weight-regular">
              <div className={`text-left credenciais-nome${credenciaisNomeLineHeight}`}>{ credenciaisNome }</div>
              <div className={`text-left credenciais-orgao${credenciaisOrgaoLineHeight}`}>{ credenciaisOrgao }</div>
              <div className={`text-left credenciais-nome-perfil${credenciaisPerfilLineHeight}`}>{ credenciaisPerfil }</div>
            </div>
            <i className={dropdownOpen ? "fas fa-caret-up" : "fas fa-caret-down"} aria-hidden="true"></i>
          </button>
          <div
            className="br-list layer-1"
            id="avatar-menu"
            role="menu"
            aria-labelledby="avatar-dropdown-trigger"
            hidden={!dropdownOpen}
          >
            <button className="br-item" role="menuitem" onClick={() => reverseSignOn({redirectToMinhaConta: true})}>
              <i className="fas fa-user" aria-hidden="true"></i>
              <span className="text ml-3">Minha conta</span>
            </button>
            {isAuthorized(CON_PREFERENCIAS) && (
            <button className="br-item" role="menuitem" onClick={() => navigate('/preferencia')}>
              <i className="fas fa-cog" aria-hidden="true"></i>
              <span className="text ml-3">Preferências</span>
            </button>
            )}
            <button className="br-item" role="menuitem" onClick={reverseSignOn}>
              <i className="fas fa-exchange-alt" aria-hidden="true"></i>
              <span className="text ml-3">Módulos</span>
            </button>
            {numVinculos > 1 && (
            <button className="br-item" role="menuitem" onClick={() => reverseSignOn({redirectToSelecionarVinculo: true})}>
              <i className="fas fa-link" aria-hidden="true"></i>
              <span className="text ml-3">Vínculos</span>
            </button>
            )}
            <button className="br-item" role="menuitem" onClick={remoteLogout}>
              <i className="fas fa-power-off" aria-hidden="true"></i>
              <span className="text ml-3">Sair</span>
            </button>
          </div>
        </Avatar>
      }
    
      {!isAuthenticated &&
        <div className="header-login">
          <div className="header-sign-in">
          <button
            className="br-sign-in primary"
            type="button"
            data-trigger="login"
            title="Acessar área restrita do Siconfi"
            onClick={handleAcessarAreaRestrita}
          >
            <i className="fas fa-user" aria-hidden="true"></i>
            <span className="d-sm-inline">Acessar área restrita</span>
          </button>
          </div>
          <div className="header-avatar"></div>
        </div>
      }
    </>
  );
}

export default Credenciais;
